// extracted by mini-css-extract-plugin
module.exports = {"header":"supplier-invoice-report_header__20Oyw","heading":"supplier-invoice-report_heading__1DJ39","filter-container":"supplier-invoice-report_filter-container__2-NJ5"};